const CV = () => {
  return (  
    <div>
      
    </div>
  );
}
 
export default CV;